import "./index.css"
import moment from 'moment'
import { useNavigate } from "react-router-dom"
import DP from "../../../../../components/custom/dp"
import { useGlobal } from "../../../../../context/global"

const Seva = props => {

    const { seva, user } = props
    const { name, date, lastDate, hasRegistered, isServiceListReady, maxDate, baseURL, selectiveClosure } = seva
    const { auth } = useGlobal()

    const isSelectivelyClosed = (selectiveClosure == "F" && !user.gender) || (selectiveClosure == "M" && user.gender)

    const navigate = useNavigate()

    const handleRegister = () => {
        navigate("/register", { state: seva })
    }

    const isLastDateElapsed = moment(lastDate, 'YYYY-MM-DD').isBefore(moment().startOf('day'))

    return <div className="flex-col volseva-main">
        <div className="volhome-feed flex-col">

            <div className="volseva-cont">
                <div className="flex-row volseva-2">
                    <div>
                        <DP url={`https://cdn.iskconmysore.org/content?path=sevabase/seva/${seva.id}.jpg`} size={[16, 6]} enlarge />
                    </div>
                    <div className="flex-col volseva-1">
                        <div className="bold volseva-name">{name}</div>
                        <div className="">{date == maxDate ? moment(date).format("dddd, Do MMM YYYY") : `${moment(date).format("ddd, Do")} - ${moment(maxDate).format("ddd, Do MMM")} ${moment(date).format("YYYY")}`}</div>
                    </div>
                </div>

                {
                    !(seva.maleOnly & !user.gender) ? <>
                        {!isLastDateElapsed
                            ? <div
                                className="volseva-info">{
                                    isSelectivelyClosed ? "Service Registration is Closed"
                                        : (hasRegistered
                                            ? 'You have registered for this seva'
                                            : `Last date for registration: ${moment(lastDate).format("Do MMM YYYY")}`)
                                }
                            </div>
                            : null}

                        {!isLastDateElapsed ?
                            (
                                !(!hasRegistered && isSelectivelyClosed)
                                    ? <button
                                        onClick={handleRegister}
                                        className="volseva-reg">
                                        {
                                            hasRegistered
                                                ? 'Modify Availability'
                                                : 'Register Now'
                                        }
                                    </button>
                                    : null)
                            : null
                        }

                    </> : null
                }

                {isServiceListReady ? <a href={`https://${baseURL || 'vol.iskconmysore.org'}/vol?name=${encodeURIComponent(auth.user.initiationName || auth.user.name)}&id=${auth.user.id}`}>
                    <button className="volseva-reg">{'Show my service'}</button>
                </a> : null}
            </div>
            <hr style={{ opacity: 0 }} />
        </div>
    </div>
}

export default Seva